import React, { ReactNode } from 'react';
import { Button, ModalBody, ModalFooter, ModalHeader, ModalProps, Modal as RSModal } from 'reactstrap';

interface ComponentProps extends ModalProps {
  className?: string;
  headerClassName?: string;
  bodyClassName?: string;
  footerClassName?: string;
  header?: ReactNode;
  isOpen?: boolean;
  footer?: ReactNode;
  setIsOpen: (toggle: boolean) => void;
  includeFooter?: boolean;
  closeButtonText?: string;
}

const Modal: React.FC<ComponentProps> = ({
  isOpen,
  setIsOpen,
  children,
  header,
  bodyClassName,
  headerClassName,
  footerClassName,
  footer,
  closeButtonText = 'Close',
  includeFooter = true,
  ...props
}) => {
  return (
    <RSModal isOpen={isOpen} {...props}>
      {header && (
        <ModalHeader
          className={headerClassName ?? 'header'}
          toggle={() => {
            setIsOpen(!isOpen);
          }}
        >
          {header}
        </ModalHeader>
      )}
      <ModalBody className={bodyClassName}>{children}</ModalBody>
      {includeFooter && (
        <ModalFooter className={footerClassName}>
          {footer ? (
            footer
          ) : (
            <Button color="secondary" onClick={() => setIsOpen(!isOpen)}>
              {closeButtonText}
            </Button>
          )}
        </ModalFooter>
      )}
    </RSModal>
  );
};

export default Modal;
